import { organisationConstants } from '../../constant';

const initialState = { organisationUsersData: [], organisationDetailsData: {} };

export const get_organisation_users_reducer = (state = initialState, action) => {
  switch (action.type) {
    case organisationConstants.GET_ORGANISATION_USERS_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case organisationConstants.GET_ORGANISATION_USERS_SUCCESS:
      return {
        loggedIn: true,
        organisationUsersData: action.payload,
      };
    case organisationConstants.GET_ORGANISATION_USERS_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    default:
      return state;
  }
};

export const get_organisation_reducer = (state = initialState, action) => {
  switch (action.type) {
    case organisationConstants.GET_ORGANISATION_REQUEST:
      return {
        type: 'alert-success',
        message: action.payload,
      };
    case organisationConstants.GET_ORGANISATION_SUCCESS:
    case organisationConstants.GET_MY_ORGANISATION_SUCCESS:
      return {
        loggedIn: true,
        organisationDetailsData: action.payload,
      };
    case organisationConstants.GET_ORGANISATION_FAILURE:
      return {
        type: 'alert-failure',
        error: action.payload,
      };
    default:
      return state;
  }
};
